import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Menu, X, Gamepad2, LogIn } from 'lucide-react';

const ArcadeNav = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { href: '#leaderboard', label: 'LEADERBOARD' },
    { href: '#what-it-is', label: 'ABOUT' },
    { href: '#how-it-works', label: 'HOW IT WORKS' },
    { href: '#side-quests', label: 'QUESTS' },
    { href: '#submit', label: 'SUBMIT' },
    { href: '#faq', label: 'FAQ' },
  ];

  return (
    <motion.nav
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-deep-purple/95 backdrop-blur-sm shadow-arcade' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Brand */}
          <a href="#" className="group">
            <span className="font-terminal text-2xl text-foreground">Singularity</span>
            <span className="font-terminal text-2xl text-trophy-gold"> Labs</span>
          </a>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="font-terminal text-lg px-3 py-2 text-lavender hover:text-neon-pink transition-colors relative group"
              >
                {link.label}
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-neon-pink group-hover:w-full transition-all duration-300" />
              </a>
            ))}
          </div>

          {/* CTA Buttons */}
          <div className="hidden md:flex items-center gap-3">
            <a
              href="/login"
              className="flex items-center gap-2 font-pixel text-[10px] px-4 py-2 text-lavender hover:text-neon-pink transition-colors border-2 border-dark-border hover:border-neon-pink rounded"
            >
              <LogIn className="w-4 h-4" />
              LOGIN
            </a>
            <a
              href="#submit"
              className="btn-arcade font-pixel text-[10px] px-4 py-2 bg-neon-pink text-dark-border hover:bg-neon-pink/90"
            >
              JOIN NOW
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden p-2 text-foreground hover:text-neon-pink transition-colors"
          >
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <motion.div
        initial={false}
        animate={{ height: isMobileMenuOpen ? 'auto' : 0, opacity: isMobileMenuOpen ? 1 : 0 }}
        className="lg:hidden overflow-hidden bg-panel-purple border-b-4 border-dark-border"
      >
        <div className="px-4 py-4 space-y-2">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={() => setIsMobileMenuOpen(false)}
              className="block font-terminal text-xl py-2 text-lavender hover:text-neon-pink transition-colors"
            >
              <Gamepad2 className="inline-block w-4 h-4 mr-2" />
              {link.label}
            </a>
          ))}
          <div className="flex gap-3 mt-4">
            <a
              href="/login"
              onClick={() => setIsMobileMenuOpen(false)}
              className="flex-1 flex items-center justify-center gap-2 font-pixel text-[10px] px-4 py-3 text-lavender border-2 border-dark-border rounded"
            >
              <LogIn className="w-4 h-4" />
              LOGIN
            </a>
            <a
              href="#submit"
              onClick={() => setIsMobileMenuOpen(false)}
              className="flex-1 btn-arcade font-pixel text-[10px] px-4 py-3 bg-neon-pink text-dark-border text-center"
            >
              JOIN NOW
            </a>
          </div>
        </div>
      </motion.div>
    </motion.nav>
  );
};

export default ArcadeNav;
